export const isActiveLink = (checkPath: string, currentPath: string) => {
  return checkPath === currentPath;
};

export const getClassName = (checkPath: string, currentPath: string) => {
  const activeClass =
    'text-link-active inline-flex items-center px-1 pt-1 text-sm font-medium';
  const inactiveClass =
    'text-default inline-flex items-center px-1 pt-1 text-sm font-medium';

  return isActiveLink(checkPath, currentPath) ? activeClass : inactiveClass;
};

export const getClassNameForMobile = (
  checkPath: string,
  currentPath: string,
) => {
  const activeClass =
    'border-transparent text-link-active px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium';
  const inactiveClass =
    'border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium';

  return isActiveLink(checkPath, currentPath) ? activeClass : inactiveClass;
};
